/* eslint-disable max-len */
// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.projects = (await import('./pages/projects/ProjectsContainer')).ProjectsContainer;
    Components.projectsMobile = (await import('./pages/projects/ProjectsMobileContainer')).ProjectsMobileContainer;
    Components.projectDetails = (await import('./pages/projectDetails/ProjectDetailsContainer')).ProjectDetailsContainer;
    Components.projectDetailsMobile = (await import('./pages/projectDetails/ProjectDetailsMobileContainer')).ProjectDetailsMobileContainer;
    Components.home = (await import('./pages/Home')).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  projects: {
    name: 'ProjectsContainer',
    componentName: 'ProjectsContainer',
    chunk: () => import('./pages/projects/ProjectsContainer'),
    get component() {
      return ssr
        ? serverPages.projects
        : currentRouteName === 'ProjectsContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProjectsContainer })));
    },
    path: '/:context?/projects',
    channel: 'desktop',
  },
  projectsMobile: {
    name: 'ProjectsMobileContainer',
    componentName: 'ProjectsMobileContainer',
    chunk: () => import('./pages/projects/ProjectsMobileContainer'),
    get component() {
      return ssr
        ? serverPages.projectsMobile
        : currentRouteName === 'ProjectsMobileContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProjectsMobileContainer })));
    },
    path: '/:context?/projects',
    channel: 'mobile',
  },
  projectDetails: {
    name: 'ProjectDetailsContainer',
    componentName: 'ProjectDetailsContainer',
    chunk: () => import('./pages/projectDetails/ProjectDetailsContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.projectDetails
        : currentRouteName === 'ProjectDetailsContainer'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProjectDetailsContainer })));
    },
    path: '/:context?/projects/:projectId',
    channel: 'desktop'
  },
  projectDetailsMobile: {
    name: 'ProjectDetailsMobileContainer',
    componentName: 'ProjectDetailsMobileContainer',
    chunk: () => import('./pages/projectDetails/ProjectDetailsMobileContainer'),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? serverPages.projectDetailsMobile
        : currentRouteName === 'ProjectDetailsMobileContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.ProjectDetailsMobileContainer })));
    },
    path: '/:context?/projects/:projectId',
    channel: 'mobile'
  },
  home: {
    name: 'Home',
    componentName: 'Home',
    chunk: () => import('./pages/Home'),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'Home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  }
});
